import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function TypesFilter({ type, search }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.typesFilter}>
      <div
        className={classNames(styles.type, {
          [styles.selected]: type === "project",
        })}
        onClick={() => search("project")}
      >
        <p className={styles.name}>{t("searchPage.types.project")}</p>
      </div>
      <div
        className={classNames(styles.type, { [styles.selected]: !type })}
        onClick={() => search(undefined)}
      >
        <p className={styles.name}>{t("searchPage.types.anyType")}</p>
      </div>
      {/*<div*/}
      {/*  className={classNames(styles.type, {*/}
      {/*    [styles.selected]: type === "task",*/}
      {/*  })}*/}
      {/*  onClick={() => search("task")}*/}
      {/*>*/}
      {/*  <p className={styles.name}>{t("searchPage.types.task")}</p>*/}
      {/*</div>*/}
      {/*<div*/}
      {/*  className={classNames(styles.type, {*/}
      {/*    [styles.selected]: type === "milestone",*/}
      {/*  })}*/}
      {/*  onClick={() => search("milestone")}*/}
      {/*>*/}
      {/*  <p className={styles.name}>{t("searchPage.types.milestone")}</p>*/}
      {/*</div>*/}
    </div>
  );
}

export { TypesFilter };
